import React, { useEffect, useState } from "react";
import TableWithDynamicPagination from "../table/table";
import WellBeEMPIService from "@services/empiService.service";
import { map, sortBy, filter } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
import MatchingMergedRecords from "./matchingMergedRecords/matchingMergdRecords";
import { formatDisplayDate } from "@utils/helpers";
import MergeEmpiComponent from "./mergeAction/mergeEmpiAction";

const AllEMPIMaster = (props: { activeTab: string }) => {
  const [columnList, setColumnList] = useState<any>([]);
  const [columnsNeedToShowInTable, setColumnsNeedToShowInTable] = useState<any>([]);
  const [columnsNeedToShowInPopUp, setColumnsNeedToShowInPopUp] = useState<any>([]);
  const [columnsNeedToShowInSearchTable, setColumnsNeedToShowInSearchTable] = useState<any>([]);
  const [columnsNeedToShowInSearchPopUp, setColumnsNeedToShowInSearchPopUp] = useState<any>([]);
  const [columnLoading, setColumnLoading] = useState(false);
  const [pendingUniqueIds, setPendingUniqueIds] = useState<any>([]);

  const fetchData = async (payload: any) => {
    console.log("AllEMPIMaster.fetchData");
    setPendingUniqueIds([]);
    const _data = await axios.post(`${sessionService.getClient()?.appServiceUrl}/empi/all-empi-master`, { ...payload }).then((response) => {
      return response.data.data.records;
    });
    return {
      totalCount: _data?.count,
      data: _data?.allEMPIMasterRecords,
    };
  };

  useEffect(() => {
    let _columns = map(columnsNeedToShowInTable, (item) => {
      if (item.key === "action_desc") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // width: 80,
          render: (value: any, record: any) => {
            return (
              <div className="ui-expandable-table__action-column-empi-master">
                <MatchingMergedRecords record={record} columnsNeedToShowInTable={columnsNeedToShowInTable} columnsNeedToShowInPopUp={columnsNeedToShowInPopUp} />
                {!record?.isEMPIMergeRequested && !pendingUniqueIds.includes(record?.member_empi_key) && (
                  <MergeEmpiComponent
                    columnsNeedToShowInSearchTable={columnsNeedToShowInSearchTable}
                    columnsNeedToShowInSearchPopUp={columnsNeedToShowInSearchPopUp}
                    record={record}
                    columnsNeedToShowInTable={columnsNeedToShowInTable}
                    columnsNeedToShowInPopUp={columnsNeedToShowInPopUp}
                    setPendingUniqueIds={setPendingUniqueIds}
                    pendingUniqueIds={pendingUniqueIds}
                    key={record?.member_empi_key}
                  />
                )}
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          // width: 150,
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else if (item.key === "member_gender") {
        return { title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      } else if (item.key === "requested_on") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          sorter: true,
          render: (value: any) => formatDisplayDate(value, "reminderDateActualFormat", "defaultDateFormat"),
        };
      } else if (item.key === "member_empi_key") {
        return { width: "20%", ellipsis: true, title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      } else {
        return { ellipsis: true, title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    setColumnList(_columns);
    setColumnLoading(false);
  }, [columnsNeedToShowInPopUp, columnsNeedToShowInSearchPopUp, columnsNeedToShowInSearchTable, columnsNeedToShowInTable, pendingUniqueIds]);

  useEffect(() => {
    setColumnLoading(true);

    // Api Call for the search Pop Up
    WellBeEMPIService.getColumnsList({ pageName: "EMPI-Stewardship-Intervention-Cases-Search" }).subscribe({
      next: (v) => {
        setColumnsNeedToShowInSearchTable(
          filter(v.data.data.columns, (item) => {
            return item.isDisplay === "Y";
          })
        );
        setColumnsNeedToShowInSearchPopUp(
          filter(v.data.data.columns, (item) => {
            return item.isAdditionalInfo === "Y";
          })
        );

        WellBeEMPIService.getColumnsList({ pageName: "EMPI-Stewardship-All-EMPI-Master" }).subscribe({
          next: (v) => {
            setColumnsNeedToShowInTable(
              filter(v.data.data.columns, (item) => {
                return item.isDisplay === "Y";
              })
            );
            setColumnsNeedToShowInPopUp(
              filter(v.data.data.columns, (item) => {
                return item.isAdditionalInfo === "Y";
              })
            );
          },
          error: (e) => {
            console.log(e);
            setColumnLoading(false);
          },
        });
      },
      error: (e) => {
        console.log(e);
      },
    });
  }, []);

  return (
    <TableWithDynamicPagination
      condition={props.activeTab === "all_empi_master"}
      dependencyProps={[props.activeTab]}
      className="ui-expandable-table"
      columns={columnList}
      handleFetchData={fetchData}
      perPageCount={10}
      columnOriginalList={columnsNeedToShowInTable}
      loading={columnLoading}
    />
  );
};

export default AllEMPIMaster;
